import React from 'react'
import Loader from 'components/D3Loader'
import { noActivitiesHumi } from '../../../assets/assets'
import moment from 'moment'

const VISIT_DATE_FORMAT = 'MMM D, YYYY h:mm A'

const VisitListItem = ({ visit }) => {
  const { name, visit_datetime: date } = visit

  return (
    <div className='visit-list-item'>
      <div className='visit-date'>{moment(date).format(VISIT_DATE_FORMAT)}</div>
      <div className='visit-title'>{name}</div>
    </div>
  )
}

const UpcomingVisitsList = ({
  loading,
  pastVisits = [],
  upcomingVisits = [],
  strings,
  humiIsabellaDisabled
}) => {
  const hasPastVisits = pastVisits.length > 0
  const hasUpcomingVisits = upcomingVisits.length > 0
  const hasVisits = hasPastVisits || hasUpcomingVisits

  return (
    <div className='upcoming-visits'>
      {loading && <Loader inContainer />}
      {!loading &&
        (hasVisits ? (
          <>
            {hasPastVisits && (
              <div className='past-visits-list'>
                {pastVisits.map((visit) => (
                  <VisitListItem key={visit.visit_id} visit={visit} />
                ))}
              </div>
            )}
            {hasUpcomingVisits && (
              <div className='upcoming-visits-list'>
                <div className='upcoming-visits-title'>
                  {strings.upcoming || 'Upcoming'}
                </div>
                {upcomingVisits.map((visit) => (
                  <VisitListItem key={visit.visit_id} visit={visit} />
                ))}
              </div>
            )}
          </>
        ) : (
          <div className='no-activities'>
            {!humiIsabellaDisabled ? (
              <img src={noActivitiesHumi} alt='no-activities-hui' />
            ) : null}
            <p>{strings.no_visits || 'You do not have any upcoming visits!'}</p>
            <p>
              {strings.visits_check_back || 'Check back soon for new ones.'}
            </p>
          </div>
        ))}
    </div>
  )
}

export default UpcomingVisitsList

UpcomingVisitsList.propTypes = {}
